<div
  class="rs-msgbox rs-msgbox-warning"
  data-tms-event="popup-impression"
  data-tms-popup-zone="alternative plans"
  data-tms-popup-name="belfius swap warning"
  attr.data-tms-product="{{ jsonProduct }}"
>
  <div class="rs-msgbox-close">
    <button class="rs-link-action rs-link-action-close close-reveal-modal">
      <span class="rs-action-link-icon" title="{{ 'common.overlayer.close.caption' | translate }}"
        ><span class="show-for-sr">{{ 'common.overlayer.close.caption' | translate }}</span></span
      >
    </button>
  </div>
  <div class="rs-msgbox-title" id="ac-beats-warning-label">
    {{ 'mobile.pricingPlan.belfius.swap.warning.title' | translate }}
  </div>
  <div class="rs-msgbox-content">
    <p [innerHTML]="'mobile.pricingPlan.belfius.swap.warning.description' | translate: true"></p>
  </div>
  <div class="rs-msgbox-footer">
    <div
      class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
    >
      <div class="rs-flex-columns rs-flex-shrink rs-order-m2">
        <a
          data-tms-button-name="confirm"
          data-tms-action-name="swap warning"
          href="javascript:void(0)"
          (click)="confirmSwap()"
          class="rs-btn rs-btn-order rs-btn-nl-so"
          >{{ 'mobile.pricingPlan.belfius.swap.warning.button.accept' | translate }}</a
        >
      </div>
      <div class="rs-flex-columns rs-order-m1">
        <button
          data-tms-button-name="cancel"
          data-tms-action-name="close"
          class="rs-btn rs-btn-second rs-btn-nl-m close-reveal-modal"
        >
          {{ 'mobile.pricingPlan.belfius.swap.warning.button.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="rs-msgbox-icon">
    <i class="icon-Warning-box" aria-hidden="true"></i>
  </div>
</div>
